import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { User } from '../../../models';
import { WorkflowContextService } from 'src/app/services';
import { Router } from '@angular/router';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'wm-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
  standalone: false
})
export class UserListComponent implements OnInit {
  @Input() users: User[];
  @Output() selected: EventEmitter<User> = new EventEmitter<User>();
  @Input() raiseEvent = false;
  @Input() searching = false;
  templateForPermitForm: boolean = false
  constructor(
   public layoutService: LayoutService,
    private _context: WorkflowContextService,
    private _router: Router
  ) {
    //added by priya 03-12-2025

  layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    //end by priya 03-12-2025

  }
  buildBaseRoute(): string[] {
    let routeDetails: string[] = [];

    if (this._context.client) {
      routeDetails = [
        'admin',
        'jurisdiction',
        this._context.client.id,
        'users'
      ];
    } else {
      routeDetails = ['admin', 'global', 'users'];
    }

    //  routeDetails = routeDetails.concat(['users']);

    return routeDetails;
  }
  editUser(user: User): boolean {
    if (window.event) {
      window.event.preventDefault();
    }
    if (this.raiseEvent) {
      this.selected.emit(user);
    } else {
      const routeDetails:
        // [START] - 2025-09-30
        // Author: Ketan Shetye
        // -------------------
        // Reason: Updated type of router -> .navigate,.createUrlTree, .createUrlTreeFromSnapshot from string[] to readonly string[]. 
        readonly string[]
        // -------------------
        // [END] - 2025-09-30
        = this.buildBaseRoute().concat(['edit', user.id]);
      this._router.navigate(routeDetails);
      return false;
    }
  }
  ngOnInit() { }
}
